<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fa fa-file"></i>
          Encuesta
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="mr-2" style="right" variant="primary" @click="goToSurveys">{{
          $t(
                  "public.views.Pages.Professional.Organization.HistoricClinics.btnBack"
          )
        }}
        </b-button>
      </template>
      <template v-slot:body>
        <tab-nav :tabs="true">
          <tab-nav-items v-for="(option, index) in survey.tabs" :id="'tab-nav-' + index" :key="index"
            :active="index < 1" :ariaSelected="true" :href="'#tab-' + index" role="tab">
            <template v-slot:title>
              {{ option.name }}
            </template>
          </tab-nav-items>
        </tab-nav>
        <tab-content>
          <tab-content-item v-for="(option, index) in survey.tabs" :id="'tab-' + index" :key="index"
            :active="index < 1">
            <div class="test-survey-builder">
              <b-row>
                <b-col v-for="(question, index) in option.questionsList" :key="index" :cols="12">
                  <div class="p-0">
                    <div class="question-section">
                      <p class="question_body">{{ question.body }}</p>
                    </div>
                    <div v-if="question.type === 'CORE'" class="option-section">
                      <b-form-group>
                        <b-form-group v-slot="{ ariaDescribedby }">
                          <span v-if="question.coreWeight !== undefined">( {{ question.coreWeight }} )</span>
                          <b-form-radio v-for="(option, index) in question.options" :key="index"
                            v-model="question.value" :aria-describedby="ariaDescribedby" :disabled="readOnly"
                            :name="'coreSelect' + question.uuid" :value="option.weight">{{ option.body }}
                            <span v-if="option.weight !== undefined">( {{ option.weight }} )</span>
                          </b-form-radio>
                        </b-form-group>
                      </b-form-group>
                    </div>
                    <div v-else class="answer-section">
                      {{ question.value }}
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </tab-content-item>
        </tab-content>
      </template>
    </iq-card>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fa fa-file"></i>
          Cálculos
        </h4>
      </template>
      <template v-slot:headerAction></template>
      <template v-slot:body>
        <b-row>
          <b-col v-for="(item, index) in surveyEngine" :key="index" :item="item" cols="2">
            {{ item.name }} : {{ Number(item.value).toLocaleString() }}
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../../config/pluginInit";

import FiveOptionsCoreSelect from "../../../../json/FiveCoreOptions";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import moment from "moment";

import surveyService from "../../../../services/survey";
import utilsService from "../../../../services/utils";

export default {
  name: "Survey",
  components: { DatePicker, VueTimepicker },
  mounted() {
    xray.index();
    if (
      this.$route.query.surveyStoreId !== undefined &&
      this.$route.query.templateUuid !== undefined &&
      this.$route.query.surveyId !== undefined
    ) {
      this.getTemplate(this.$route.query.templateUuid);
      this.getSurveyEngines(this.$route.query.surveyId);


      utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_SURVEY", info: "" });
    } else {
      this.goToDashboard();
    }
  },

  methods: {
    goToSurveys() {
      this.$router.push({
        name: "auth.professional.contact.surveys",
        query: { surveyStoreId: this.$route.query.surveyStoreId },
      });
    },
    goToDashboard() {
      this.$router.push({
        name: "auth.professional.dashboard",
      });
    },
    questionaryToSurvey() {
      let self = this;
      if (this.survey && this.survey.tabs && this.survey.tabs.length !== 0) {
        this.survey.tabs.forEach(function (tab) {
          if (tab && tab.questionsList && tab.questionsList.length !== 0) {
            tab.questionsList.forEach(function (question) {
              let obj = {
                question: question.body === null ? "" : question.body,
                value: question.value === null ? "" : question.value,
              };
              self.variable.push(obj);
            });
          }
        });
      }
    },
    async getSurvey(surveyId) {
      let self = this;

      this.$awn.asyncBlock(
        surveyService.getSurvey(surveyId),
        (response) => {
          if (response) {
            //self.survey = response.data;
            let survey = response.data;

            if (
              self.survey &&
              self.survey.tabs &&
              self.survey.tabs.length !== 0
            ) {
              self.survey.tabs.forEach(function (tab) {
                if (
                  tab &&
                  tab.questionsList &&
                  tab.questionsList.length !== 0
                ) {
                  tab.questionsList.forEach(function (question) {
                    response.data.surveyQuestions.forEach(function (item) {
                      if (item.question === question.body) {
                        question.value = item.value;
                      }
                    });
                  });
                }
              });
            }
          }
        },
        (error) => {
          self.goToDashboard();
        },
        " "
      );
    },
    async getSurveyEngines(surveyId) {
      let self = this;

      this.$awn.asyncBlock(
        surveyService.getSurveyEngines(surveyId),
        (response) => {
          if (response) {
            self.surveyEngine = response.data;

            self.surveyEngine.sort(function (a, b) {
              if (a.position > b.position) {
                return 1;
              }
              if (a.position < b.position) {
                return -1;
              }
              // a must be equal to b
              return 0;
            });
          }
        },
        (error) => {
          self.goToDashboard();
        },
        " "
      );
    },
    async getTemplate(uuid) {
      let self = this;

      this.$awn.asyncBlock(
        surveyService.getTemplate(uuid),
        (response) => {
          if (response) {
            self.survey = response.data;
            this.getSurvey(this.$route.query.surveyId);
          }
        },
        (error) => {
          self.goToDashboard();
        },
        " "
      );
    },
    store() {
      let self = this;

      this.questionaryToSurvey();

      let obj = {
        surveyQuestions: this.variable,
        surveyId: this.$route.query.surveyId,
      };

      this.$awn.asyncBlock(
        surveyService.complete(obj),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_SURVEY", info: "" });
            self.$router.push({
              name: "auth.patient.dashboard",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "surveyService.complete",
            module: "view-pages-professional-contact-surveys",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              obj: obj
            })
          });
        },
        " "
      );
    },
    vdropzoneSuccess: function (question, file, response) {
      question.value =
        process.env.VUE_APP_BASE_URL_CORE + "public/file/" + response.uuid;
    },
    multiChoiceTransformJson(question) {
      let str = "";
      if (
        question.valueTmp &&
        (question.type === "MULTI_CHOICE" ||
          question.type === "SINGLE_CHOICE" ||
          question.type === "BOOLEAN")
      ) {
        if (question.options && question.options.length !== 0) {
          question.options.forEach(function (option) {
            if (question.valueTmp.includes(option.sequence)) {
              if (str) {
                str = str + " - " + option.body;
              } else {
                str = option.body;
              }
            }
          });
        }

        question.value = str;
      }
    },
    updateTime(question) {
      if (question.valueTmp) {
        question.value = question.valueTmp.HH + ":" + question.valueTmp.mm;
      }
    },
    updateDate(question) {
      question.value = moment(question.valueTmp).format("DD/MM/yyyy");
    },
  },

  data() {
    return {
      surveyEngine: [],
      fiveOptionsCoreSelect: FiveOptionsCoreSelect,
      organizationId: localStorage.getItem("organizationId"),
      //Form dynamic
      readOnly: false,
      configCK: {
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: "",
        language: "es",
      },
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
      //----
      survey: {},
      badge: {
        color: null,
        text: null,
      },
      variable: [],
      comments: "",
    };
  },
};
</script>
